import { HttpClient } from '@wix/http-client';

export class HttpClientFactory {
  private defaultTimeout = 25000;

  private defaultHttpClient: HttpClient;

  constructor(private readonly baseUrl: string) {
    this.defaultHttpClient = new HttpClient({
      baseURL: this.baseUrl,
      timeout: this.defaultTimeout,
    });
  }

  public createClient(baseUrl: string, timeout?: number): HttpClient {
    return new HttpClient({
      baseURL: baseUrl,
      timeout: timeout ?? this.defaultTimeout,
      createHeaders: () => {
        if (timeout) {
          return { 'x-time-budget': `${timeout}` };
        }
        return {};
      },
    });
  }

  public getDefaultClient(): HttpClient {
    return this.defaultHttpClient;
  }
}
